// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__Cu7vb","title":"ClientInsurance_title__1G4D9","itemText":"ClientInsurance_itemText__1mO-d"};